module.exports = __webpack_public_path__ + "static/media/search.250fccf6.svg";